import {avatarShapeClasses, avatarSizeClasses, avatarSizeStyle} from './avatar-variants';
import {cn} from '../../lib/utils';
import {Skeleton} from '../shadcn/skeleton';

import type {AvatarShape, AvatarSize} from './avatar-variants';
import type {ComponentProps} from 'react';

export interface AvatarSkeletonProps extends ComponentProps<'div'> {
  size?: AvatarSize;
  shape?: AvatarShape;
}

/** Shares `Avatar`'s size/shape vocabulary so the placeholder can't render a different silhouette. */
export function AvatarSkeleton({
  className,
  size = 'default',
  shape = 'circle',
  style,
  ...props
}: AvatarSkeletonProps) {
  return (
    <Skeleton
      data-slot="avatar-skeleton"
      data-size={size}
      data-shape={shape}
      style={{...avatarSizeStyle(size), ...style}}
      className={cn('shrink-0 rounded-full', avatarSizeClasses, avatarShapeClasses, className)}
      {...props}
    />
  );
}
